import { starCases, netCases } from '@/mocks/home';

type CaseItem = { title: string; meta: string; cover: string };

type ColumnProps = {
  title: string;
  subtitle: string;
  icon: string;
  iconClass: string;
  tagClass: string;
  items: CaseItem[];
};

function CaseColumn({ title, subtitle, icon, iconClass, tagClass, items }: ColumnProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center gap-3 border-b border-background-100 pb-4">
        <span className={`flex h-9 w-9 items-center justify-center rounded-md text-lg ${iconClass}`}>
          <i className={icon}></i>
        </span>
        <div>
          <h3 className="font-heading text-lg font-bold text-foreground-950">{title}</h3>
          <p className="text-xs text-foreground-500">{subtitle}</p>
        </div>
      </div>
      <ul className="divide-y divide-background-100">
        {items.map((item) => (
          <li key={item.title}>
            <a href="#feed" className="group flex items-center gap-3 py-3">
              <img
                src={item.cover}
                alt={item.title}
                title={item.title}
                className="h-16 w-16 shrink-0 rounded-md object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <span className="line-clamp-2 block text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className={`mt-1.5 inline-block rounded px-1.5 py-0.5 text-xs ${tagClass}`}>{item.meta}</span>
              </div>
              <i className="ri-arrow-right-s-line text-lg text-foreground-400 group-hover:text-primary-600"></i>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function CategoryColumns() {
  return (
    <section id="category" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">黑料脉络 · 分线追踪</h2>
          <p className="mt-1 text-sm text-foreground-600">明星与网红两条线分开跟，谁的瓜更好吃一目了然</p>
        </div>

        <div className="grid gap-5 lg:grid-cols-2">
          <CaseColumn
            title="明星黑料"
            subtitle="影视音乐综艺现场 · 4 条在追"
            icon="ri-star-smile-line"
            iconClass="bg-primary-100 text-primary-700"
            tagClass="bg-primary-100 text-primary-700"
            items={starCases}
          />
          <CaseColumn
            title="网红黑料"
            subtitle="直播短视频电商圈 · 4 条在追"
            icon="ri-live-line"
            iconClass="bg-accent-100 text-accent-800"
            tagClass="bg-accent-100 text-accent-800"
            items={netCases}
          />
        </div>
      </div>
    </section>
  );
}